export default __webpack_public_path__ + "static/media/Pandora.f74d32b8.svg";